import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';

// Pages and Components
import Dashboard from './pages/Dashboard';
import LoginPage from './components/auth/LoginPage';
import StockDetail from './components/trading/StockDetail';
import PortfolioManager from './components/portfolio/PortfolioManager';
import NotFound from './pages/NotFound';
import StrategyConfig from './pages/StrategyConfig';
import StockAnalysis from './pages/StockAnalysis';
import Reports from './pages/Reports';
import About from './pages/About';

// Wrapper component for StockDetail to get URL parameters
const StockDetailWrapper: React.FC = () => {
  const { ticker } = useParams<{ ticker: string }>();
  return <StockDetail ticker={ticker || ''} />;
};

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Main Dashboard Route */}
      <Route
        path="/"
        element={
          <MainLayout title="Dashboard">
            <Dashboard />
          </MainLayout>
        }
      />
      
      {/* Authentication Routes */}
      <Route
        path="/login"
        element={<LoginPage />}
      />
      <Route
        path="/register"
        element={<LoginPage initialMode="register" />}
      />
      
      {/* Strategy Configuration */}
      <Route
        path="/config"
        element={
          <MainLayout title="Strategy Configuration">
            <StrategyConfig />
          </MainLayout>
        }
      />
      
      {/* Stock Analysis Pages */}
      <Route
        path="/stocks"
        element={
          <MainLayout title="Stock Analysis">
            <StockAnalysis />
          </MainLayout>
        }
      />
      <Route
        path="/stock/:ticker"
        element={
          <MainLayout title="Stock Analysis">
            <StockDetailWrapper />
          </MainLayout>
        }
      />
      
      {/* Reports */}
      <Route
        path="/reports"
        element={
          <MainLayout title="Trading Reports">
            <Reports />
          </MainLayout>
        }
      />
      
      {/* Portfolio Route */}
      <Route
        path="/portfolio"
        element={
          <MainLayout title="Portfolio Manager">
            <PortfolioManager />
          </MainLayout>
        }
      />
      
      {/* About Page */}
      <Route
        path="/about"
        element={
          <MainLayout title="About">
            <About />
          </MainLayout>
        }
      />
      
      {/* 404 Route */}
      <Route
        path="*"
        element={
          <MainLayout title="Page Not Found">
            <NotFound />
          </MainLayout>
        }
      />
    </Routes>
  );
};

export default AppRoutes; 